import { UserOutlined } from '@ant-design/icons';
import { Card, Col, Flex, Layout, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { CButton } from '@/components/CButton';
import { HeaderLogo } from '@/components/HeaderLogo';
import { PageBanner } from '@/components/PageBanner';
import { FooterLinks } from '@/modules/auth/components/FooterLinks';

const { Header } = Layout;
const { Text, Link } = Typography;

const TermsServices = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['common', 'pages/login']);
  return (
    <Layout className="h-dvh c-legal-page">
      <Header className="header">
        <Flex justify="space-between" align="center" className="w-full">
          <Col>
            <Flex align="center">
              <div className="logo">
                <HeaderLogo />
              </div>
            </Flex>
          </Col>
          <Col className="flex justify-end">
            <CButton
              startIcon={<UserOutlined />}
              onClick={() => navigate('/login')}
              variant="primary"
            >
              {t('common:common.login')}
            </CButton>
          </Col>
        </Flex>
      </Header>
      <PageBanner title={t('pages/login:pages.login.footer.terms_of_service')} />

      <Layout className="layout-content">
        <Card className="p-0">
          <section className="flex flex-col mb-4">
            <Text strong>1. Acceptance of Terms</Text>
            <Text>
              By using this internal application (the "API Client"), you agree to be bound by these
              Terms of Service. This application is intended for internal use within Conthand.
            </Text>
          </section>
          <section className="flex flex-col mb-4">
            <Text strong>2. YouTube Terms of Service</Text>
            <Text>
              All users of this application are also bound by the{' '}
              <strong>YouTube Terms of Service</strong>, which can be found at:{' '}
              <Link href="https://www.youtube.com/t/terms" target="_blank">
                https://www.youtube.com/t/terms
              </Link>
              . By using this API Client, you acknowledge and agree to comply with these YouTube
              terms.
            </Text>
          </section>
          <section className="flex flex-col mb-4">
            <Text strong>3. Contact Information</Text>
            <Text>
              For any questions regarding these terms, please contact:{' '}
              <strong>bt@merzigo.com</strong>
            </Text>
          </section>
        </Card>
      </Layout>

      <FooterLinks />
    </Layout>
  );
};

export default TermsServices;
